import { connect } from "react-redux";
import { Form, Formik } from "formik";
import { FC, useRef, useState } from "react";

import DropDown from "../../../commonComponent/dropDown/DropDown";
import FilterButton from "../../../commonComponent/tableFilter/FilterButton";
import {
  getFilterQueryString,
  getStatus,
  getStatusArr,
} from "../../../../helpers/helperFunction";
import { masterDataModal } from "app/reducers/masterData/masterDataReducer";
import {
  ResetButton,
  SubmitButton,
} from "app/components/commonComponent/buttons/Buttons";
import { useGetFilterObject, useOutsideAlerter } from "app/helpers/customHooks";
import { PAYMENT_STATUS } from "app/helpers/constants";
import CustomDatePicker from "app/components/commonComponent/datePicker/CustomDatePicker";

export const timeVariationOptions = [
    { value: "exact", name: "Exact Time (No Variation)" },
    { value: "less", name: "Under Time (Less)" },
    { value: "more", name: "Over Time (More)" },
    { value: "less_gt_1", name: "Under Time > 1 Hour" },
    { value: "more_gt_1", name: "Over Time > 1 Hour" },
];

interface TaskTimeFilterProps {
  masterDataList: masterDataModal;
}

const TaskTimeFilter: FC<TaskTimeFilterProps> = ({ masterDataList }) => {
  const { filterObj, searchObj, setSearchParam } = useGetFilterObject();
  const [showDropDown, setShowDropDown] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);
  useOutsideAlerter(wrapperRef, setShowDropDown);

  const resetHandler = (resetForm: any) => {
    delete searchObj.Filters;
    resetForm();
    setSearchParam({ ...searchObj, PageNumber: "1" });
  };

  return (
    <div className="position-relative" ref={wrapperRef}>
      <FilterButton
        setShowDropDown={setShowDropDown}
        showDropDown={showDropDown}
      />
      <div
        className={`shadow-sm card w-300px w-sm-400px w-md-500px task-filter ${
          showDropDown ? "" : "hidden"
        }`}
      >
        <div className="p-7">
          <div className="fs-5 text-dark fw-bolder">Filter</div>
        </div>
        <div className="separator border-gray-200"></div>
        <Formik
          enableReinitialize
          initialValues={filterObj}
          onSubmit={async (values: any) => {
            setSearchParam({
              ...searchObj,
              PageNumber: "1",
              Filters: getFilterQueryString(values),
            });
          }}
        >
          {({ values, isSubmitting, setFieldValue, resetForm }) => {
            return (
              <Form noValidate className="form">
                <div className="mb-10 px-9 pt-3">
                  <div className="row">
                    <div className="col-md-12 mb-12">
                      <label className="col-form-label fw-semibold fs-6">
                        Time Variation
                      </label>

                      <div className="fv-row">
                        <DropDown
                          className={`text-start form-control form-control-lg form-control-solid form-select`}
                          placeholder="Select Time Variation"
                          options={timeVariationOptions}
                          setFieldValue={setFieldValue}
                          name="TimeVariation"
                          currentValue={{
                            value: values.TimeVariation || "all",
                            name: timeVariationOptions.find(opt => opt.value === values.TimeVariation)?.name || "All"
                          }}
                          defaultValue={{
                            value: values.TimeVariation || "all",
                            name: timeVariationOptions.find(opt => opt.value === values.TimeVariation)?.name || "All"
                          }}
                          showSearch={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end pb-6 px-6 gap-3">
                  <ResetButton
                    name="Reset"
                    className="btn btn-light btn-active-light-primary btn-sm"
                    onClickCallback={() => {
                      resetHandler(resetForm);
                      setShowDropDown(false);
                    }}
                  />
                  <SubmitButton
                    isSubmitting={isSubmitting}
                    name="Apply"
                    className="btn btn-primary btn-sm"
                    onClickCallback={() => setShowDropDown(false)}
                  />
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    masterDataList: state.masterData,
  };
};

export default connect(mapStateToProps)(TaskTimeFilter);
